import React, { useEffect, useState } from "react";
import "./WebCheckinTags.css";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../customHooks/useAuth";
import axiosInstance from "../../../axiosInstance/axiosInstance";
import PageLoader from "../../components/PageLoader/PageLoader";
import { toast } from "react-toastify";

export default function WebCheckInTags() {

    // Refresh Handle
    useAuth();

    const location = useLocation();

    // Necessary Data
    const bookingId = location.state?.bookingId || "";
    const userId = localStorage.getItem("user_id");
    const hotelId = location.state?.hotelId || ""; 

    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
    const status = location.state?.status || "";
    const activeTab = location.state?.activeTab || "";
    const hotelName = location.state?.hotelName || "";
    const hotelAddress = location.state?.hotelAddress || "";

    const guests = location.state?.guests || [];
    const bookedRooms1 = location.state?.bookedRooms1 || [];

    const tagItems = location.state?.tags || [];
    const timeArrival = location.state?.timeArrival || "";


    const [isLoading,setIsLoading] = useState(false);


    const navigate = useNavigate();
    const sections = [
        {
            title: "Purpose of stay",
            options: [
            "Leisure/Wellness Vacation",
            "Honeymoon",
            "Anniversary",
            "Birthday Celebration",
            "Family Vacation",
            "Friends Trip",
            "Workcation",
            "Corporate Offsite",
            "Adventure Trip",
            "Spiritual Retreat",
            ],
        },
        {
            title: "Travelling with",
            options: [
            "Solo",
            "Couple",
            "Family",
            "Friends",
            "Colleagues",
            "Kids",
            "Pets",
            ],
        },
        {
            title: "Dietary preferences",
            options: [
            "Vegetarian",
            "Eggetarian",
            "Vegan",
            "Jain",
            "Non-Vegetarian",
            ],
        },
        {
            title: "Arrival preference",
            label: "Arriving by",
            options: [
            "Self drive",
            "Cab",
            "Bus",
            "Flight",
            "Train",
            ],
        },
        {
            title: "Interests during stay",
            options: [
            "Adventure sports",
            "Trekking & Hiking",
            "Local Tours",
            "Local Arts",
            "Wildlife",
            "Local shopping",
            "Couple outings",
            "Off beat locations",
            "Family outings",
            ],
        },
    ];

    // Stores selected options for each section
    const [selectedTags, setSelectedTags] = useState(tagItems);

    const handleTagClick = (sectionTitle, option) => {
    try {
        setSelectedTags((prev) => {
            if (sectionTitle === "Arrival preference") {
                const current = prev[sectionTitle] || [];

                return {
                    ...prev,
                    [sectionTitle]: current.includes(option) ? [] : [option],
                };
            }

            const current = prev[sectionTitle] || [];

            const updated = current.includes(option)
                ? current.filter((item) => item !== option)
                : [...current, option];

            return {
                ...prev,
                [sectionTitle]: updated,
            };
        });
    } catch (error) {
        console.log(error);
    }
};

    const moveToCheckin = ()=>{
        try{
            navigate("/webCheckin",
                {
                    state : {
                        hotelId,
                        bookingId,
                        checkInDate,
                        checkOutDate,
                        status,
                        activeTab,
                        hotelName,
                        hotelAddress,
                        guests,
                        bookedRooms : bookedRooms1,
                        selectedTags : selectedTags,
                        timeArrival
                    }
                }
            )
        }catch(error){
            console.log(error);
        }

    }

    const checkInSubmit = async () => {
        try {
            setIsLoading(true);

            const formatSelectedTags = (selectedTags) => {
                const formatted = {
                    purpose: [],
                    travelling_with: [],
                    dietary: [],
                    interests: [],
                    arrival: "",
                };

                Object.entries(selectedTags).forEach(([key, value]) => {
                    switch (key) {
                        case "Purpose of stay":
                            formatted.purpose = value;
                            break;

                        case "Travelling with":
                            formatted.travelling_with = value;
                            break;

                        case "Arrival preference":
                            formatted.arrival = value.length ? value[0] : "";
                            break;

                        case "Dietary preferences":
                            formatted.dietary = value;
                            break;

                        case "Interests during stay":
                            formatted.interests = value;
                            break;

                        default:
                            break;
                    }
                });

                return formatted;
            };

            const formattedTags = formatSelectedTags(selectedTags);

            // Add booked_room_id to each guest

            const updatedGuests = guests.flatMap((roomGuests, roomIndex) => {
                const bookedRoomId = bookedRooms1[roomIndex]?.booked_room_id;

                return roomGuests.map((guest) => ({
                    ...guest,
                    booked_room_id: bookedRoomId,
                }));
            });

            const passData = {
                checkin_date: checkInDate,
                checkout_date: checkOutDate,
                ...formattedTags,
                arrival_time: timeArrival || "",
                guests: updatedGuests,
                number_of_guests : updatedGuests?.length || 0
            };

            const response = await axiosInstance.put(
                `/api/v1/users/${userId}/bookings/${bookingId}/web-checkin`,
                passData
            );

            toast.success("WebCheckIn for added guest completed");
            navigate("/webCheckinSuccess", {
                state: {
                    guests: updatedGuests,
                    bookingId,
                    hotelId,
                    checkInDate,
                    checkOutDate,
                    status,
                    activeTab,
                    hotelName,
                    hotelAddress,
                    bookedRooms: bookedRooms1,
                    selectedTags: selectedTags,
                    timeArrival
                },
            });
        } catch (error) {
            toast.error(error?.response?.data?.message || "Some Error Occured");
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    // Check If Booking Id and HotelId are there or not
    useEffect(()=>{
        const checkData = ()=>{
          if(bookingId==="" || hotelId===""){
            navigate("/bookings");
          }
        }
        checkData();
    },[bookingId,hotelId,navigate]);

  return (
    <>
        {
            isLoading && <PageLoader/>
        }
        <div className="webcheckin-tags">
            {/* Header */}
            <div className="personalize-header">
                <div className="header-content">
                <button className="back-btn" onClick={()=>moveToCheckin()}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M15 5l-7 7 7 7"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    </svg>
                </button>

                <div className="header-text">
                    <h2>Personalise your stay</h2>
                    <p>Step 2 of 2 · Optional · skip anytime</p>
                </div>

                <div className="progress">
                    <span className="active"></span>
                    <span className="active"></span>
                </div>
                </div>
            </div>

            {/* Content */}
            <div className="personalize-body">
                <p className="intro">
                A few optional details so we can tailor your stay.
                <strong> Skip anytime</strong> — your check-in is already done.
                </p>

                {sections.map((section) => (
                <div className="section" key={section.title}>
                    <h3>{section.label || section.title}</h3>

                    <div className="options">
                    {section.options.map((item) => {
                        const isSelected =
                        selectedTags[section.title]?.includes(item);

                        return (
                        <button
                            key={item}
                            className={`option-btn ${isSelected ? "active" : ""}`}
                            onClick={() =>
                            handleTagClick(section.title, item)
                            }
                        >
                            {item}
                        </button>
                        );
                    })}
                    </div>
                </div>
                ))}
            </div>

            {/* Footer */}
            <div className="personailize-footer-actions">
                <div className="personailize-footer-buttons">
                    <div className="personailize-skip-wrapper">
                        <button className="personailize-skip-button" onClick={()=>checkInSubmit()}>
                            Skip
                        </button>
                    </div>
                    <div className="personailize-save-wrapper">
                        <button className="personailize-save-button" onClick={()=>checkInSubmit()}>
                            Save &amp; finish
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </>
  );
}